module.exports = __webpack_public_path__ + "static/media/aragorn.f0a7b130.png";